export default {
  isInternalReport: (state) => state.reportType === 'internal',
};
